export function loadTabsConsultaPosPagamentoRequest(IdContrato, IdMenu) {
  return {
    type: '@posPagamentoContrato/LOAD_TABS_CONSULTA_REQUEST',
    payload: { IdContrato, IdMenu},
  };
}

export function loadTabsConsultaPosPagamentoSuccess(tabs) {
  return {
    type: '@posPagamentoContrato/LOAD_TABS_CONSULTA_SUCCESS',
    payload: { tabs },
  };
}

export function loadTabsAnalisePosPagamentoRequest(IdContrato, reanalise) {
  return {
    type: '@posPagamentoContrato/LOAD_TABS_ANALISE_REQUEST',
    payload: { IdContrato, reanalise },
  };
}

export function loadTabsAnaliseSuccess(tabs) {
  return {
    type: '@posPagamentoContrato/LOAD_TABS_ANALISE_SUCCESS',
    payload: { tabs },
  };
}

export function setCurrentFila(currentFila) {
  return {
    type: '@posPagamentoContrato/SET_CURRENT_FILA',
    payload: currentFila
  };
}
